// @flow

import { onlyWhenSupport , type UserInputValidationError, type UserInputValidatorArgs, VALID} from '@tectonics/prs/validation';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';
import {getCountry} from '@tectonics/prs/incoming-payment';
import { getCountryFromCode } from '@tectonics/commons/country';
import { getCustomerDocumentConfig } from '@tectonics/commons/customer-form/get-customer-document-config';
import { getCustomerPhoneNumberConfig } from '@tectonics/commons/customer-form/get-phone-number-config';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const countryCode = getCountry(incomingPayment);
  const country = getCountryFromCode(countryCode);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  const {
    documentValidationFunction,
    specDocumentName,
    documentInputFieldName,
  } = getCustomerDocumentConfig(country);

  const {
    phoneNumberValidationFunction,
    phoneNumberInputFieldName,
  } = getCustomerPhoneNumberConfig(country);

  switch (userInputName) {
    case documentInputFieldName:
      if (
        !hasOptionalField(optionalFields, 'document')
        && documentValidationFunction
        && specDocumentName
      ) {
        return onlyWhen(specDocumentName) && documentValidationFunction(userInputValue);
      }
      return VALID;

    case phoneNumberInputFieldName:
      if (
        !hasOptionalField(optionalFields, 'telephone')
        && phoneNumberValidationFunction
        && phoneNumberInputFieldName
      ) {
        return phoneNumberValidationFunction(userInputValue);
      }
      return VALID;

    default:
      return VALID;
  }
}
